import { render, staticRenderFns } from "./TextFields.vue?vue&type=template&id=64ad6eb2&"
import script from "./TextFields.vue?vue&type=script&lang=js&"
export * from "./TextFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports